import React, { useState, useEffect } from "react";
import { useFieldArray } from "react-hook-form";
import PositionListItem from "../positionListItem/PositionListItem";
import InputFieldFormArray from "../inputFieldFormArray/InputFieldFormArray";
import "./AdPosition.css";

export default ({
  control,
  register,
  index,
  setManageCreatives,
  manageCreatives,
  creativeNumber,
}) => {
  const { fields, remove, append } = useFieldArray({
    control,
    name: `creatives[${index}].adPositions`,
  });

  const [positionNumber, setPositionNumber] = useState(0);

  // This button is used to switch between adPositions to be shown on the screen.
  function displayPosition(e, number) {
    e.preventDefault();
    setPositionNumber(number);
  }

  // Here were add new buttons to the manageCreative object which is used to show the right number of adPositions buttons.
  function addPositionNumber(e) {
    e.preventDefault();
    const positionToBeAdded =
      manageCreatives[creativeNumber].adPositions.length;

    const newPosition = {
      position: positionToBeAdded + 1,
      positionsList: [{ title: 0 }],
    };

    const data = manageCreatives.map((item, index) =>
      index === creativeNumber
        ? {
            ...item,
            adPositions: [...item.adPositions, newPosition],
          }
        : item
    );

    setManageCreatives(data);
  }

  // Here we delete the adPosition button from the manageCreatives object when an adPosition is deleted from the form.
  function removeAdPositionNumber(indexToBeRemoved) {
    let newItem = [];
    manageCreatives.map((item, index) => {
      if (index !== creativeNumber) {
        newItem.push(item);
      } else {
        let newCreativeObject = {
          creative: item.creative,
          adPositions: [],
        };
        item.adPositions.map((position, index) => {
          if (index !== indexToBeRemoved) {
            newCreativeObject.adPositions.push(position);
          }
        });
        newItem.push(newCreativeObject);
      }
    });
    setManageCreatives(newItem);

    setPositionNumber(indexToBeRemoved - 1);
  }

  // Here we first set underlining of the active adPositions.
  return (
    <div className="form-wrapper-ad-position">
      {manageCreatives[creativeNumber]?.adPositions.map((item, indexButton) => {
        let underline = "";
        let color = "";

        if (indexButton === positionNumber) {
          underline = "position-underline";
          color = "position-color";
        } else {
          underline = "";
          color = "";
        }
        return (
          <span
            key={indexButton}
            className={`position-wrapper-form ${underline}`}
          >
            <p
              className={`display-position-button positions${indexButton} ${color}`}
              key={indexButton}
              onClick={(e) => {
                displayPosition(e, indexButton);
              }}
            >
              {`Display Ad position ${indexButton + 1}`}
            </p>
          </span>
        );
      })}

      <ul>
        {fields.map((item, indexAdPosition) => {
          return (
            <li key={item.id}>
              {indexAdPosition === positionNumber && (
                <div>
                  <div className="add-position-button-wrapper">
                    <button
                      className="add-button"
                      onClick={(e) => {
                        addPositionNumber(e, index);
                        append({
                          position: "",
                          positionsList: [
                            {
                              type: "fixedPosition",
                              title: "",
                              htmlName: "",
                              details: [
                                {
                                  title: "",
                                  infoFields: [
                                    {
                                      subject: "",
                                      text: "",
                                      type: "text",
                                      url: "",
                                    },
                                  ],
                                },
                              ],
                            },
                          ],
                          extraInformation: "",
                        });
                      }}
                    >
                      Add position number
                    </button>
                  </div>

                  {indexAdPosition === positionNumber && (
                    <div className="input-container">
                      <div className="inner-input-position-container">
                        <div className="position-form-wrapper">
                          <InputFieldFormArray
                            label={`Position ${indexAdPosition + 1} name `}
                            placeholder="Rectangle"
                            fieldRef={register(
                              `creatives[${index}].adPositions[${indexAdPosition}].position`,
                              {
                                required: false,
                              }
                            )}
                            name={`creatives[${index}].adPositions[${indexAdPosition}].position`}
                            key={item.id}
                          />

                          <button
                            className="position-button delete-button"
                            type="button"
                            onClick={() => {
                              remove(indexAdPosition);
                              removeAdPositionNumber(indexAdPosition);
                            }}
                          >
                            Delete
                          </button>
                        </div>

                        <PositionListItem
                          {...{
                            control,
                            register,
                            index,
                            indexAdPosition,
                            setManageCreatives,
                            manageCreatives,
                            creativeNumber,
                            positionNumber,
                          }}
                        />
                      </div>
                    </div>
                  )}
                </div>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};
